import { render } from "./TestVolumeReport.vue?vue&type=template&id=5b18dfe3&scoped=true"
import script from "./TestVolumeReport.vue?vue&type=script&lang=js"
export * from "./TestVolumeReport.vue?vue&type=script&lang=js"

import "./TestVolumeReport.vue?vue&type=style&index=0&id=5b18dfe3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b18dfe3"]])

export default __exports__